import { defineStore } from 'pinia';
import { configRequest } from 'config-request';
import { useGlobalStore } from './global';
import { getRequestIns } from '../requestIns';
export const useDiscountStore = defineStore('discount-list', {
    state() {
        return {
            data: null,
            selectedDiscountCode: '',
        };
    },
    getters: {
        disCountList() {
            if (!this.data?.discount_list.length)
                return [];
            return this.data.discount_list.map((item) => {
                return item;
            });
        },
        currentDiscount() {
            const item = this.disCountList.find((discount) => {
                return discount.code === this.selectedDiscountCode;
            }) ?? null;
            return item;
        },
    },
    actions: {
        // 获取指定的科技包内容
        getDiscountItem(code) {
            if (!this.data?.discount_list?.length)
                return;
            return (this.data.discount_list.find((item) => {
                return item.code === code;
            }) ?? null);
        },
        setSelectedDiscountCode(code) {
            this.selectedDiscountCode = code;
        },
        updateDiscountConfig() { },
        formatDiscountList(data) {
            this.selectedDiscountCode = '';
            if (!this.data?.discount_list?.length)
                return;
            data.discount_list.forEach((item, index) => {
                if (item.matched === 0) {
                    this.selectedDiscountCode = item.code;
                }
            });
        },
        /**
         * 获取科技包列表
         * @param params
         */
        async getDisCountList() {
            const globalStore = useGlobalStore();
            const currentFlatOptions = globalStore.currentFlatOptions;
            const option_list = globalStore.currentOptionList.map((item) => ({
                ...item,
            }));
            const params = {
                generation_code: currentFlatOptions.generation_code,
                model_code: currentFlatOptions.model_code,
                option_list,
            };
            const result = await configRequest(getRequestIns()).disCountList(params);
            this.data = result.data || {};
            this.formatDiscountList(result.data);
        },
    },
});
